module.exports = __webpack_public_path__ + "static/img/icon-7.0a6d947e.png";